module.exports = __webpack_public_path__ + "static/c3-16c1a93341e27d384f03069abeacfb89.jpeg";